import React from 'react';
import { Link } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';
import Navigation from '../components/Navigation';

export default function NotFoundPage() {
  // Set page meta for 404 page
  usePageMeta(
    'Page Not Found | Smile Consent - Dental Digital Consent Software',
    'The page you are looking for could not be found. Return to our homepage to explore our dental consent form solutions.',
    'https://smileconsent.co.uk/404'
  );

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center">
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-blue-600 mb-4">404</h1>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Page Not Found</h2>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Sorry, the page you are looking for doesn't exist or has been moved. 
              Let's get you back to our dental consent form solutions.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link
              to="/"
              className="bg-blue-600 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-blue-700 transition-colors"
            >
              Go to Homepage
            </Link>
            <Link
              to="/dental-consent-forms"
              className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-xl text-lg font-semibold hover:bg-blue-50 transition-colors"
            >
              View Consent Forms
            </Link>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Dental Consent Forms</h3>
              <p className="text-gray-600 mb-4">200+ GDC & CQC compliant templates</p>
              <Link to="/dental-consent-forms" className="text-blue-600 hover:text-blue-700 font-medium">
                Explore Forms →
              </Link>
            </div>
            
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Pricing Plans</h3>
              <p className="text-gray-600 mb-4">Unlimited users, no per-user fees</p>
              <Link to="/dental-consent-plans" className="text-blue-600 hover:text-blue-700 font-medium">
                View Plans →
              </Link>
            </div>
            
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Compliance Software</h3>
              <p className="text-gray-600 mb-4">CQC inspection ready solutions</p>
              <Link to="/dental-compliance-software" className="text-blue-600 hover:text-blue-700 font-medium">
                Learn More →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
